// Shared filter helpers for Platform Alerts analytics drill-down modals.
//
// The level-2 "Vehicles Affected" table can be scoped by a bus-number search.
// That search must be applied identically on BOTH surfaces:
//   1. the table fetch (getLevel2TableData), and
//   2. the download/mail action (applyLevel2TableAction).
// Both paths call this single function so the two can never drift apart.

/**
 * Build the bus-number search filter fragment for a level-2 drill-down request.
 * Returns a spreadable array: the licensePlateNumber filter when devices are
 * selected, otherwise an empty array.
 *
 * @param {string[]} selectedDevices - license plate numbers from the search bar
 * @returns {Array<{name: string, values: string[]}>}
 */
export const deviceSearchFilter = (selectedDevices) =>
  selectedDevices?.length > 0
    ? [{ name: "licensePlateNumber", values: selectedDevices }]
    : [];
